import { decodeJwt } from '../../shared/services/authService';
import { MIC_PAIRING_PURPOSE } from './micProtocol';

export type MicJoinErrorCode = 'missing_token' | 'invalid_token' | 'expired_token';

export interface MicJoinOk {
  token: string;
  pairingId: string;
}

export type LocationLike = Pick<Location, 'protocol' | 'hostname' | 'port' | 'host'>;

export function parseMicPairingToken(
  token: string | null | undefined,
): MicJoinOk | { error: MicJoinErrorCode } {
  if (!token) return { error: 'missing_token' };
  const payload = decodeJwt(token);
  if (
    !payload ||
    payload.purpose !== MIC_PAIRING_PURPOSE ||
    typeof payload.pairingId !== 'string' ||
    payload.pairingId.length < 8
  ) {
    return { error: 'invalid_token' };
  }
  if (typeof payload.exp === 'number' && payload.exp * 1000 <= Date.now()) {
    return { error: 'expired_token' };
  }
  return { token, pairingId: payload.pairingId };
}

/**
 * URL del relay. En Vite (5173/4173) usa el puerto 1236 del mismo host
 * para que un teléfono en LAN no apunte a localhost del móvil.
 * Desplegado, el relay cuelga de /mic-relay en el mismo host: es una regla
 * del Ingress (k8s/*\/web-app/ingress.yml). Sin ese sufijo el WebSocket
 * acabaría en el pod del frontend.
 */
export function micRelayWsUrl(
  location: LocationLike = window.location,
  envUrl: string | undefined = import.meta.env.VITE_MIC_RELAY_WS_URL as string | undefined,
): string {
  if (typeof envUrl === 'string' && envUrl.trim()) return envUrl.trim();
  const proto = location.protocol === 'https:' ? 'wss:' : 'ws:';
  if (location.port === '5173' || location.port === '4173') {
    return `${proto}//${location.hostname}:1236`;
  }
  return `${proto}//${location.host}/mic-relay`;
}

export function formatMicDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}
